import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/authContext'; // Import your auth context
import DialogConfirmation from './dialogs/DialogConfirmation';
import Layout from './Layout'
import { hasAllPrivileges } from '../utils';

// privillege means the required privillege(s) to access the route. If the user is admin, they can access all routes regardless of privillege. If the user is sub-admin, they must have all the specified privilleges to access the route.
// when privillege is null, only admin can access the route. when privillege is an empty array, both admin and sub-admin can access the route.
const PrivateRoute = ({ element, containLayout = true, privileges = null }) => {
    const { user, userData, loading } = useAuth(); // Get user from context

    if (loading) {
        return <DialogConfirmation
            open={loading}
            onClose={() => { }}
            type="loading"
            title="Please wait"
            message="We are processing your booking request. Please wait and don’t close this page"
            buttonText="Cancel"
            onButtonClick={
                () => { }
            }
        />
    }
10
    return user ?
        ((userData?.role === 'admin' || (privileges != null && userData?.role === "sub-admin" && hasAllPrivileges(userData?.privileges, privileges)))) ?
        (
            containLayout ?
                <Layout>
                    {element}
                </Layout>
                :
                element
        )
        :
        <div> loading </div>
        : <Navigate to="/login" />;
};

export default PrivateRoute;